module.exports = __webpack_public_path__ + "img/wheelMay2019.bb95a85c.svg";